import type { Campaign } from '@/api/types/graphql';
// import { registerStore } from '@/modules/common';
import { createStore } from 'vuex';

export interface State {
  campaign?: Campaign;
  campaigns: Campaign[]; // Initialized as an empty array
  campaignThemePage?: Campaign;
  isNewFeature: boolean;
  isQueryCampaigns: boolean;
  isLoadingUpdateState: boolean;
  isShowHighlightSelect: boolean;
  isFetchedCampaignThemePage: boolean;
}

const campaignStore = createStore<State>({
  state: {
    campaign: undefined,
    campaigns: [], // Initialized as an empty array
    campaignThemePage: undefined,
    isNewFeature: false,
    isQueryCampaigns: false,
    isLoadingUpdateState: false,
    isShowHighlightSelect: false,
    isFetchedCampaignThemePage: false,
  },
  getters: {
    getCampaign: (state) => state.campaign,
    getCampaigns: (state) => state.campaigns,
    getCampaignThemePage: (state) => state.campaignThemePage,
    getIsNewFeature: (state) => state.isNewFeature,
    getIsQueryCampaigns: (state) => state.isQueryCampaigns,
    getIsLoadingUpdateState: (state) => state.isLoadingUpdateState,
    getIsShowHighlightSelect: (state) => state.isShowHighlightSelect,
    getIsFetchedCampaignThemePage: (state) => state.isFetchedCampaignThemePage,
  },
  mutations: {
    setCampaign(state, payload: Campaign) {
      state.campaign = payload;
    },
    setCampaigns(state, payload: Campaign[]) {
      state.campaigns = payload;
    },
    setCampaignThemePage(state, payload: Campaign) {
      state.campaignThemePage = payload;
    },
    setIsNewFeature(state, payload: boolean) {
      state.isNewFeature = payload;
    },
    setIsQueryCampaigns(state, payload: boolean) {
      state.isQueryCampaigns = payload;
    },
    setIsLoadingUpdateState(state, payload: boolean) {
      state.isLoadingUpdateState = payload;
    },
    setIsShowHighlightSelect(state, payload: boolean) {
      state.isShowHighlightSelect = payload;
    },
    setIsFetchedCampaignThemePage(state, payload: boolean) {
      state.isFetchedCampaignThemePage = payload;
    },
    upsertCampaign(state, payload: Campaign) {
      const index = state.campaigns.findIndex((c) => c.id === payload.id);
      if (index !== -1) {
        state.campaigns[index] = { ...state.campaigns[index], ...payload };
      } else {
        state.campaigns.push(payload);
      }
    },
  },
});

export function useCampaignStore() {
  return campaignStore;
}
